var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0371 7.87663C10.3024 7.87663 9.58104 7.76172 8.89745 7.53581C8.56248 7.42156 8.1507 7.52638 7.94626 7.73634L6.59698 8.75491C5.03221 7.91963 4.06833 6.95606 3.24446 5.40303L4.23305 4.08891C4.48989 3.83241 4.58202 3.45772 4.47164 3.10616C4.24477 2.41897 4.12952 1.69794 4.12952 0.962937C4.12955 0.431969 3.69758 0 3.16665 0H0.962904C0.431968 0 0 0.431969 0 0.962906C0 7.04884 4.95117 12 11.0371 12C11.568 12 12 11.568 12 11.0371V8.8395C12 8.30859 11.568 7.87663 11.0371 7.87663Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone.53afe191f40fddb3a05bac54a5b390a8.svg";